import { GetCyberSourceContextResponse } from '~/entities/responses/getCyberSourceContextResponse';
import { GetSetupAuthResponse } from '~/entities/responses/getSetupAuthResponse';
import { GetPostCsPaymentResponse } from '~/entities/responses/getPostCsPaymentResponse';
import { GetCsValidatePaymentResponse } from '~/entities/responses/getCsValidatePaymentResponse';
import { GetPostPaymentResponse } from '~/entities/responses/getPostPaymentResponse';
import { logger } from '~/utils/func/logger';

import { APIService } from './ApiService';
import { CardInfos } from './PaymentService';
import { CryptoService } from './CryptoService';

export interface SetupAuthPaymentBody {
  transactionRef: string;
  channelId: string;
  paymentMethod?: string;
  cardInfos?: CardInfos;
  cardDetails?: CardDetails;
}

interface CardDetails {
  cardNumber?: string;
  cardExpiryMonth: string;
  cardExpiryYear: string;
  cardType?: string;
  cardVV?: string;
}

export interface ValidatePaymentBody {
  transactionRef: string;
  channelId: string;
  paymentMethod: string;
  authorizationId: string;
  cardDetails?: CardDetails;
}

export const CyberSourceService = {
  async getPaymentContext(): Promise<GetCyberSourceContextResponse> {
    const res = await APIService.call('GET', `/payment/context`);
    return res.data;
  },
  async payerSetupAuth(body: SetupAuthPaymentBody): Promise<GetSetupAuthResponse> {
    const res = await APIService.call('POST', `/payment/setup/auth`, body);
    return res.data;
  },
  async processPayment(body: SetupAuthPaymentBody): Promise<GetPostCsPaymentResponse> {
    logger.debug('processPaymentBody', { prefix: 'CyberSource', data: body });
    const res = await APIService.call('POST', `/payment/pay`, body, undefined, undefined, undefined, undefined, true);
    const resData = res.data.data;

    const crypto = new CryptoService();
    crypto.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
    const decryptData = crypto.decryptData(resData) as GetPostPaymentResponse;
    logger.debug('decryptData processPayment', { prefix: 'CyberSource', data: decryptData });
    return decryptData;
  },
  async validatePayment(body: ValidatePaymentBody): Promise<GetCsValidatePaymentResponse> {
    const res = await APIService.call(
      'POST',
      `/payment/pay/validate`,
      body,
      undefined,
      undefined,
      undefined,
      undefined,
      true,
    );
    const resData = res.data.data;

    const crypto = new CryptoService();
    crypto.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
    const decryptData = crypto.decryptData(resData) as GetCsValidatePaymentResponse;
    logger.debug('decryptData validatePayment', { prefix: 'CyberSource', data: decryptData });
    return decryptData;
  },
};
